import React, { Component } from 'react';
import Slider from 'react-slick';

class WebinarSlider extends Component {

    render() {

        const settings = {
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true
        };

        return (
            <section className="row product-page-reviews">
                <div className="col-xs-12">
                    <div className="slider-wrapper">
                        <div className="frame-3 frame-white">
                            <Slider className="slider-webinar-reviews" ref={c => this.slider = c } {...settings}>
                                <div key={1} className="slide">
                                    <div className="review-body">
                                        <div className="review">
                                            <p className="p-tag">
                                                "I have so enjoyed this course. It has felt like a present to myself at a turning point in my career. My self confidence has shot through the roof. And I consequently feel more able to look at the things I find more difficult in my professional life - acknowledge them - and work on them."
                                            </p>
                                        </div>
                                        <div className="webinar-user-name">
                                            <p className="p-tag">User Name</p>
                                            <p className="p-tag">Ahead of the Curve Member</p>
                                        </div>
                                    </div>
                                </div>
                                <div key={2} className="slide">
                                    <div className="review-body warning">
                                        <div className="review">
                                            <p className="p-tag">
                                                "I have so enjoyed this course. It has felt like a present to myself at a turning point in my career. My self confidence has shot through the roof. And I consequently feel more able to look at the things I find more difficult in my professional life - acknowledge them - and work on them."
                                            </p>
                                        </div>
                                        <div className="webinar-user-name">
                                            <p className="p-tag">User Name</p>
                                            <p className="p-tag">Ahead of the Curve Member</p>
                                        </div>
                                    </div>
                                </div>
                                <div key={3} className="slide">
                                    <div className="review-body warning">
                                        <div className="review">
                                            <p className="p-tag">
                                                "I have so enjoyed this course. It has felt like a present to myself at a turning point in my career. My self confidence has shot through the roof. And I consequently feel more able to look at the things I find more difficult in my professional life - acknowledge them - and work on them."
                                            </p>
                                        </div>
                                        <div className="webinar-user-name">
                                            <p className="p-tag">User Name</p>
                                            <p className="p-tag">Ahead of the Curve Member</p>
                                        </div>
                                    </div>
                                </div>

                            </Slider>
                        </div>
                    </div>
                </div>
            </section>

        );

    }

}

export default WebinarSlider;


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/WebinarSlider.js